/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：RQs1
 */

// removed by extract-text-webpack-plugin
module.exports = {
  "templateItem": "templateItem_rMyH8",
  "gif": "gif_1sPty",
  "image": "image_2uJTr",
  "openTemplate": "openTemplate_2XCQQ",
  "templateName": "templateName_2ZQ2c",
  "templateDesc": "templateDesc_2rk92"
}

/***/
